import { render, staticRenderFns } from "./OnboardingStepper.vue?vue&type=template&id=85cbfbd6&"
import script from "./OnboardingStepper.vue?vue&type=script&lang=js&"
export * from "./OnboardingStepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports